import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import * as words from '../../../../services/language'
import { MessageService } from '../../../../services/message.service';
import { MasterService } from '../../../../services/master.service';
import { StoreService } from '../../../../services/store.service';
import { Subject, Subscription } from "rxjs";
import { SEARCH_DEBOUNCE_MILLIS } from "src/app/constants/list";
import { Sale } from 'src/app/models/sale.model';

@Component({
    selector: 'collectors',
    templateUrl: './collectors.component.html',
    styleUrls: ['./collectors.component.scss'],
    standalone: false
})
export class CollectorsComponent implements OnInit {

    // Currently selected language
    @Input() language: string = 'EN'

    // Word replacements for each language.
    @Input() words: Object = words.language

    //
    protected sales: Array<Sale> = []

    //
    private records: number = 0

    //
    private page: number = 1

    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    // Indicates whether any more data is available
    protected exhausted: boolean = false

    // The receipt number search form group
    protected form: FormGroup | null = null

    /** A debounce timer for search events. Used to wait for the user to stop typing before we fetch. */
    private watcher: ReturnType<typeof setTimeout> | null = null

    constructor (private route: ActivatedRoute, private router: Router, private ms: MessageService, private master: MasterService, private store: StoreService, private fb: FormBuilder) {
        this.form = this.fb.group({
            lot: new FormControl<number>(0, [])
        })
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.watcher) {
            clearTimeout(this.watcher)
            this.watcher = null
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
    }

    private reset = (): void => {
        this.page = 1
        this.exhausted = false
        this.records = 0
    }

    private fetch = (): void => {
        if (this.loading) {
            return
        }

        if (this.exhausted) { // currently showing all available records?
            return
        }

        this.loading = true
        if (this.page === 1) {
            this.sales = []
        }

        this.master.get(`sales`, (res) => {
            this.loading = false
  
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }
  
            this.records = res.data.records
            this.exhausted = (res.data.next === null)
  
            if (this.page > 1) {
                this.sales = this.sales.concat(res.data.sales)
                return
            }
  
            this.sales = res.data.sales
        })
    }
}
